import pixelDb from "@/pixels/ofertaEmprendedores/pixelDb";

describe("pixelDb config", () => {
  it("configuracion exportada por defecto", () => {
    expect(pixelDb).toBeDefined();
    expect(pixelDb).not.toBeNull();
    expect(typeof pixelDb).toBe("object");
  });
});
